module.exports = __webpack_public_path__ + "static/media/eid-card.svg?v=8ce79628";